import { useState, useEffect } from 'react'

interface ReadingProgress {
  [key: string]: {
    currentPosition: number
    totalLength: number
    lastRead: string
    completed: boolean
  }
}

export function useLocalProgress() {
  const [progress, setProgress] = useState<ReadingProgress>({})

  useEffect(() => {
    const saved = localStorage.getItem('reading-progress')
    if (saved) {
      try {
        setProgress(JSON.parse(saved))
      } catch (error) {
        console.error('Failed to parse reading progress:', error)
      }
    }
  }, [])

  const updateProgress = (
    manualId: string,
    currentPosition: number,
    totalLength: number
  ) => {
    const newProgress = {
      ...progress,
      [manualId]: {
        currentPosition,
        totalLength,
        lastRead: new Date().toISOString(),
        completed: currentPosition >= totalLength * 0.95 // 95% completion threshold
      }
    }
    
    setProgress(newProgress)
    localStorage.setItem('reading-progress', JSON.stringify(newProgress))
  }

  const getProgress = (manualId: string) => {
    return progress[manualId] || {
      currentPosition: 0,
      totalLength: 0,
      lastRead: '',
      completed: false
    }
  }

  const getProgressPercentage = (manualId: string) => {
    const data = getProgress(manualId)
    if (data.totalLength === 0) return 0
    return Math.round((data.currentPosition / data.totalLength) * 100)
  }

  const markCompleted = (manualId: string) => {
    const current = getProgress(manualId)
    updateProgress(manualId, current.totalLength, current.totalLength)
  }

  return {
    progress,
    updateProgress,
    getProgress,
    getProgressPercentage,
    markCompleted
  }
}
